"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var ThemeProvider_1 = require("../theme/ThemeProvider");
var react_native_1 = require("react-native");
var ATLAtomIcon_1 = require("../atoms/ATLAtomIcon");
var ATLAtomLabel_1 = require("../atoms/ATLAtomLabel");
var NavigationButtonTypeEnum_1 = require("../enums/NavigationButtonTypeEnum");
var defaultProps = {
    complementary: false,
    type: NavigationButtonTypeEnum_1.NavigationButtonTypeEnum.internal,
    labelBaseProps: {},
    leftIconBaseProps: {},
    rightIconButtonBaseProps: {},
};
// ASSETS --------------------------------------------------------------------------------------------------------------
var arrow = require('../assets/next_white.png');
var externalArrow = require('../assets/navigationButtonIcon.png');
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
exports.NavigationButtonWrapper = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  flex-direction: row;\n  min-height: ", "px;\n\tpadding:  ", "px\n\t          ", "px;\n"], ["\n  flex-direction: row;\n  min-height: ", "px;\n\tpadding:  ", "px\n\t          ", "px;\n"])), function (_a) {
    var atlTheme = _a.theme;
    return atlTheme.SizeIconBase;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.verticalMargin || atlTheme.SpacingBase;
}, function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalMargin || atlTheme.SpacingMarginal;
});
exports.LeftElementWrapper = native_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tmargin: 0 ", "px 0 0;\n"], ["\n\tmargin: 0 ", "px 0 0;\n"])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalPadding || atlTheme.SpacingMarginal;
});
exports.RightElementWrapper = native_1.default(react_native_1.View)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tmargin: 0 0 0 ", "px;\n"], ["\n\tmargin: 0 0 0 ", "px;\n"])), function (_a) {
    var atlTheme = _a.theme, props = __rest(_a, ["theme"]);
    return props.horizontalPadding || atlTheme.SpacingBase;
});
exports.TextWrapper = native_1.default(react_native_1.View)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\tflex: 1;\n\tjustify-content: center;\n"], ["\n\tflex: 1;\n\tjustify-content: center;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])));
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLNavigationButton = function (_a) {
    var leftIcon = _a.leftIcon, text = _a.text, onPressCell = _a.onPressCell, complementary = _a.complementary, type = _a.type, horizontalMargin = _a.horizontalMargin, horizontalPadding = _a.horizontalPadding, verticalMargin = _a.verticalMargin, labelBaseProps = _a.labelBaseProps, leftIconBaseProps = _a.leftIconBaseProps, rightIconBaseProps = _a.rightIconBaseProps;
    var theme = ThemeProvider_1.useTheme();
    // Renders Left Icon
    var renderLeftIcon = function (img) { return (react_1.default.createElement(exports.LeftElementWrapper, { horizontalPadding: horizontalPadding },
        react_1.default.createElement(ATLAtomIcon_1.ATLAtomIcon, __assign({ source: img, size: theme.SizeIconBase, tintColor: complementary ? theme.ColorComplementary1 : theme.ColorBrand2Default }, leftIconBaseProps)))); };
    // Renders right arrow button
    var renderRightIcon = function () { return (react_1.default.createElement(exports.RightElementWrapper, { horizontalPadding: horizontalPadding },
        react_1.default.createElement(ATLAtomIcon_1.ATLAtomIcon, __assign({ source: type === NavigationButtonTypeEnum_1.NavigationButtonTypeEnum.external ? externalArrow : arrow, tintColor: complementary ? theme.ColorComplementary1 : theme.ColorMediumContrast, size: theme.SizeIconBase }, rightIconBaseProps)))); };
    // Renders Text
    var renderText = function () { return (react_1.default.createElement(exports.TextWrapper, null,
        react_1.default.createElement(ATLAtomLabel_1.ATLAtomLabel, __assign({ fontFamily: theme.FontFamilySystem, fontSize: theme.FontSizeBody, fontWeight: theme.FontWeightNormal, lineHeight: theme.LineHeightBase, textColor: complementary ? theme.ColorComplementary1 : theme.ColorHighContrast }, labelBaseProps), text))); };
    // Returns complete ATLNavigationButton
    return (react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: onPressCell },
        react_1.default.createElement(exports.NavigationButtonWrapper, { horizontalMargin: horizontalMargin, verticalMargin: verticalMargin },
            leftIcon && renderLeftIcon(leftIcon),
            renderText(),
            renderRightIcon())));
};
exports.ATLNavigationButton.defaultProps = defaultProps;
exports.ATLNavigationButton.displayName = 'ATLNavigationButton';
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
